module.exports = __webpack_public_path__ + "AdobeStock_593430244_crop1.jpg?22c30dc295121f2a6123e3c00ac9eae7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newborn/AdobeStock_593430244_crop1.jpg
// module id = 372
// module chunks = 0